import css from 'styled-jsx/css';

const styles = css`:global(.card){width:420px}:global(.sign-up-button){width:200px !important;margin:auto;margin-top:16px}.sign-up-form-attention{margin-top:1.3rem;font-size:.875rem;line-height:1.3125rem}`;

export default styles;